// src/config/voices.ts

// -----------------------------------------------------------------------------
// Pre-recorded Base64 audio imports (MUST be at top for eslint import/first)
// -----------------------------------------------------------------------------

// Daniel clips (already converted)
import {
  DANIEL_GREETING_BASE64,
  DANIEL_RETRIEVE_HOMEWORK_BASE64,
  DANIEL_SELECT_HOMEWORK_BASE64,
  DANIEL_SAVE_HOMEWORK_BASE64,
  DANIEL_SAVE_EXPOSURE_BASE64,
  DANIEL_RETRIEVE_COPING_BASE64,
  DANIEL_PROCESS_REQUEST_BASE64,
} from "../audio/base64/daniel";

// Jone clips (already converted)
import {
  JONE_GREETING_BASE64,
  JONE_RETRIEVE_HOMEWORK_BASE64,
  JONE_SELECT_HOMEWORK_BASE64,
  JONE_SAVE_HOMEWORK_BASE64,
  JONE_SAVE_EXPOSURE_BASE64,
  JONE_RETRIEVE_COPING_BASE64,
  JONE_PROCESS_REQUEST_BASE64,
} from "../audio/base64/jone";


// Bradley clips (already converted)
import {
  BRADLEY_GREETING_BASE64,
  BRADLEY_RETRIEVE_HOMEWORK_BASE64,
  BRADLEY_SELECT_HOMEWORK_BASE64,
  BRADLEY_SAVE_HOMEWORK_BASE64,
  BRADLEY_SAVE_EXPOSURE_BASE64,
  BRADLEY_RETRIEVE_COPING_BASE64,
  BRADLEY_PROCESS_REQUEST_BASE64,
} from "../audio/base64/bradley";

// Clarice clips (already converted)
import {
  CLARICE_GREETING_BASE64,
  CLARICE_RETRIEVE_HOMEWORK_BASE64,
  CLARICE_SELECT_HOMEWORK_BASE64,
  CLARICE_SAVE_HOMEWORK_BASE64,
  CLARICE_SAVE_EXPOSURE_BASE64,
  CLARICE_RETRIEVE_COPING_BASE64,
  CLARICE_PROCESS_REQUEST_BASE64,
} from "../audio/base64/clarice";

// -----------------------------------------------------------------------------
// Voice keys
// -----------------------------------------------------------------------------
export type VoiceKey = "jone" | "bradley" | "clarice" | "daniel";
export const DEFAULT_VOICE_KEY: VoiceKey = "clarice";

// -----------------------------------------------------------------------------
// Base64 clip set (optional per voice)
// -----------------------------------------------------------------------------
export type VoiceBase64Set = {
  greeting?: string;
  retrieveHomework?: string;
  selectHomework?: string;
  saveHomework?: string;
  saveExposure?: string;
  retrieveCoping?: string;
  processRequest?: string;
};

// -----------------------------------------------------------------------------
// Voice profile (static capabilities + fallback voice)
// -----------------------------------------------------------------------------
export type VoiceProfile = {
  key: VoiceKey;
  label: string;

  // ElevenLabs fallback voice
  elevenLabsVoiceId: string;
};

// -----------------------------------------------------------------------------
// Static voice definitions
// -----------------------------------------------------------------------------
export const VOICES: Record<VoiceKey, VoiceProfile> = {
  jone: {
    key: "jone",
    label: "Jone (Nurturing Guide)",
    elevenLabsVoiceId: "UShdpPZj9t1Kgb9ACOS2",
  },

  bradley: {
    key: "bradley",
    label: "Bradley (Earnest Narrator)",
    elevenLabsVoiceId: "RexqLjNzkCjWogguKyff",
  },

  clarice: {
    key: "clarice",
    label: "Clarice (Customer Care)",
    elevenLabsVoiceId: "sIak7pFapfSLCfctxdOu",
  },

  daniel: {
    key: "daniel",
    label: "Daniel (efa chat)",
    elevenLabsVoiceId: "HNH8EepuYaHKCoXJhiyo",
  },
};

// -----------------------------------------------------------------------------
// Pre-recorded Base64 audio lookup
// -----------------------------------------------------------------------------
export const VOICE_BASE64: Partial<Record<VoiceKey, VoiceBase64Set>> = {
  daniel: {
    greeting: DANIEL_GREETING_BASE64,
    retrieveHomework: DANIEL_RETRIEVE_HOMEWORK_BASE64,
    selectHomework: DANIEL_SELECT_HOMEWORK_BASE64,
    saveHomework: DANIEL_SAVE_HOMEWORK_BASE64,
    saveExposure: DANIEL_SAVE_EXPOSURE_BASE64,
    retrieveCoping: DANIEL_RETRIEVE_COPING_BASE64,
    processRequest: DANIEL_PROCESS_REQUEST_BASE64,
  },
  jone: {
    greeting: JONE_GREETING_BASE64,
    retrieveHomework: JONE_RETRIEVE_HOMEWORK_BASE64,
    selectHomework: JONE_SELECT_HOMEWORK_BASE64,
    saveHomework: JONE_SAVE_HOMEWORK_BASE64,
    saveExposure: JONE_SAVE_EXPOSURE_BASE64,
    retrieveCoping: JONE_RETRIEVE_COPING_BASE64,
    processRequest: JONE_PROCESS_REQUEST_BASE64,
  },
  bradley: {
    greeting: BRADLEY_GREETING_BASE64,
    retrieveHomework: BRADLEY_RETRIEVE_HOMEWORK_BASE64,
    selectHomework: BRADLEY_SELECT_HOMEWORK_BASE64,
    saveHomework: BRADLEY_SAVE_HOMEWORK_BASE64,
    saveExposure: BRADLEY_SAVE_EXPOSURE_BASE64,
    retrieveCoping: BRADLEY_RETRIEVE_COPING_BASE64,
    processRequest: BRADLEY_PROCESS_REQUEST_BASE64,
  },
  clarice: {
    greeting: CLARICE_GREETING_BASE64,
    retrieveHomework: CLARICE_RETRIEVE_HOMEWORK_BASE64,
    selectHomework: CLARICE_SELECT_HOMEWORK_BASE64,
    saveHomework: CLARICE_SAVE_HOMEWORK_BASE64,
    saveExposure: CLARICE_SAVE_EXPOSURE_BASE64,
    retrieveCoping: CLARICE_RETRIEVE_COPING_BASE64,
    processRequest: CLARICE_PROCESS_REQUEST_BASE64,
  },
};
